(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/init.js');
"use strict";


const {
  getModalRoot,
  QuickplayModal
} = svs.components.sport.quickplayModal;

function init(_ref) {
  let {
    branding,
    productId,
    drawNumber,
    hasSaveButton,
    systemCost,
    systemType,
    rowPrice,
    productSizes,
    isPixMix = false,
    initiator
  } = _ref;
  const app = React.createElement(QuickplayModal, {
    branding: branding,
    drawNumber: parseInt(drawNumber, 10),
    hasSaveButton: hasSaveButton,
    initiator: initiator,
    isPixMix: isPixMix,
    productId: parseInt(productId, 10),
    productSizes: productSizes,
    rowPrice: parseFloat(rowPrice),
    systemCost: parseFloat(systemCost),
    systemType: systemType
  });
  const root = getModalRoot({
    unmount: true
  });
  ReactDOM.render(app, root);
}
setGlobal('svs.components.sport.quickplayModal.init', init);

 })(window);